module.exports = __webpack_public_path__ + "static/media/main_bg.cd990210.jpg";